import React from "react";
import styled from "styled-components";
import { IconPlus } from "@arco-design/web-react/icon";

// A distinct "add" row pinned under a Select's options (via dropdownRender):
// separated by a divider and tinted with the brand accent so it reads as an
// action, not a selectable option. The caller's onClick typically closes the
// dropdown and opens a create dialog (or navigates).
const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  margin-top: 4px;
  border-top: 1px solid var(--color-border-2);
  color: rgb(var(--arcoblue-6));
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: rgb(var(--arcoblue-1));
  }
`;

export default function AddDropdownFooter({ label, onClick }) {
  return (
    <Row onMouseDown={(e) => e.preventDefault()} onClick={onClick}>
      <IconPlus /> {label}
    </Row>
  );
}
